import toast from "react-hot-toast";

import { ModelEventEnum } from "@/consts/AnalyticsEvent";
import { useAnalytics } from "@/features/common/hooks/useAnalytics";
import { useErrorHandling } from "@/features/common/hooks/useErrorHandling";
import { useInvalidateQueries } from "@/features/common/hooks/useInvalidateQueries";
import {
  AccessTypeEnum,
  useCreateModelPhotosMutation,
} from "@/generated/graphql-hooks";
import AddPhotoIcon from "@/icons/editAlbum/add_photo.svg";
import { uploadImages } from "@/services/cloudinary/uploadImages";

export const UploadPhotoButton = ({
  accessType,
}: {
  accessType: AccessTypeEnum;
}) => {
  const { trackEvent } = useAnalytics();
  const { handleGraphqlError } = useErrorHandling();
  const { mutateAsync: createModelPhotos, isLoading } =
    useCreateModelPhotosMutation();
  const { invalidateQueries } = useInvalidateQueries();

  const onUpload = async (files: FileList) => {
    try {
      const uploadedPhotos = await uploadImages(files);
      await createModelPhotos({ photos: uploadedPhotos, accessType });
      invalidateQueries(["ModelPhotos.infinite"]);
      toast.success("成功新增相片");
      trackEvent(ModelEventEnum.CREATE_PHOTOS, { accessType });
    } catch (error) {
      handleGraphqlError(error, {
        tags: {
          action: "UploadPhotoButton.onUpload",
        },
      });
    }
  };

  return (
    <label htmlFor="uploadPhotos">
      <div
        className={
          isLoading ? "cursor-not-allowed" : "cursor-pointer hover:opacity-70"
        }
      >
        <AddPhotoIcon />
      </div>
      <input
        disabled={isLoading}
        id="uploadPhotos"
        name="uploadPhotos"
        type="file"
        className="sr-only"
        multiple
        onChange={(e) => onUpload(e.target.files)}
      />
    </label>
  );
};
